import { SET_TITLE } from '../actions';
import { TitleService } from '../../services';

export default () => (next) => (action) => {
  if (action.type === SET_TITLE) {
    TitleService.setTitle(action.payload);
  }
  next(action);
};
